import React, { Component } from "react"

export default class LoginForm extends Component {
    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this)
    }

    onSubmit(event) {
        event.preventDefault()
        this.props.requestLogin(this.emailInput.value, this.passwordInput.value)
    }

    render() {
        return (
            <form id="userForm" name="userForm" onSubmit={this.onSubmit}>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        ref={input => (this.emailInput = input)}
                        className="form-control"
                        name="email"
                        placeholder="Email address"
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        ref={input => (this.passwordInput = input)}
                        className="form-control"
                        name="password"
                        placeholder="Password"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="btn btn-info btn-login"
                    name="submit"
                >
                    Log in
                </button>
                <p
                    className="login-note"
                    onClick={this.props.toggleForm("resetForm")}
                >
                    I forgot my username and/or password
                </p>
            </form>
        )
    }
}
